/**
 * Parsers for the three per-code invite settings (#2022 Part A): trial-grant
 * amount, trial-grant validity, and daily activation quota.
 *
 * Shared rather than page-local because two surfaces now write the same three
 * values onto a code — the mint dialog on the invite-codes page and the
 * one-click provisioning drawer on the ops-users page. They must agree on
 * what a valid entry is: a drawer that accepted `12.345` yuan where the
 * dialog refused it would send a rounded amount the operator never typed.
 */

export const CENTS_PER_YUAN = 100;

/** Digits only, positive, safe integer. Returns null for anything else. */
export function parsePositiveInt(raw: string): number | null {
  const trimmed = raw.trim();
  if (!/^\d+$/.test(trimmed)) {
    return null;
  }
  const parsed = Number.parseInt(trimmed, 10);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
}

/** Yuan in, cents out. Rejects empty, non-finite, non-positive, and sub-cent. */
export function parseGrantYuanToCents(raw: string): number | null {
  const trimmed = raw.trim();
  const grantYuan = Number(trimmed);
  const grantCents = Math.round(grantYuan * CENTS_PER_YUAN);
  if (
    trimmed.length === 0 ||
    !Number.isFinite(grantYuan) ||
    grantCents <= 0 ||
    Math.abs(grantYuan * CENTS_PER_YUAN - grantCents) > 1e-6
  ) {
    return null;
  }
  return grantCents;
}
